<template>
    <div id="about">
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu/>
        </div>

        <div>
            <div class="section section-color center">
                <div class="w-container" style="padding:50px 0 0 0">
                    <h1 class="key-number">LocalScale for Home Service Providers</h1>
                </div>
            </div>

            <div class="center" style="margin:20px 30px">
                <div class="industry-container">
                    <div class="industry-text">
                        <p style="font-size: 18px;font-weight:bold">Transform your home service provider business with LocalScale, your strategic partner in targeted advertising for residential service professionals</p>
                        <p>Whether you're a handyman offering general repair and maintenance services, a plumbing expert fixing leaks and installing pipes, an electrician ensuring the safety of electrical systems, or a landscaping company beautifying outdoor spaces, LocalScale can enhance your visibility and connect you with homeowners in your target neighborhoods and zip codes.</p>
                        <p>From cleaning companies specializing in housekeeping and deep cleaning to HVAC technicians keeping homes comfortable year-round, our precision-targeted ad network enables you to reach individuals actively seeking your services.</p>
                        <p>Let us help you grow your business and become the go-to choice for homeowners in your community.</p>
                        <div class="button-group" style="margin-top: 20px;margin-bottom: 10px;">
                            <div class="navigation-action"><a href="signup.html" class="ds-button button-small w-button">{{$t('get_started')}}</a></div>
                        </div>
                    </div>
                    <div class="industry-image">
                        <img src="images/industry-home-and-maintenance.png" alt="Home And Maintenance">
                    </div>
                </div>
            </div>

            <div style="width: 100%;background-color:#e6faf6;">
                <div class="testimonial">
                    <div class="testimonial-stars">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                    </div>
                    <h3 class="testimonial-quote">“LocalScale has been a game-changer for our landscaping business. Their targeted advertising solutions have allowed us to reach homeowners in our area who are looking for professional landscaping services. Thanks to LocalScale, we've seen a significant increase in inquiries and new clients, helping us grow our business and establish ourselves as a trusted choice for residential landscaping projects.”</h3>
                    <p class="testimonial-customer">– Greg Miller, Owner of Green Thumb Landscaping</p>
                </div>
            </div>

            <Plans :what_are_you_waiting_for="true"/>
        </div>

        <Footer/>

    </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu";
import NetworkStatus from "../components/NetworkStatus.vue";
import Footer from "../components/Footer";
import Plans from "../components/Plans";

export default {
    components: {
        HeaderMenu, NetworkStatus, Footer, Plans
    }
}
</script>

<style>
body {
    font-family: Inter, sans-serif;
    background-color: #fff;
}
p {
    color: black;
    margin: 10px;
    font-size: 16px;
}
h2 {
    text-align: center;
}
a {
    text-decoration: none;
    color: #1f1f1f
}
</style>
